const defaultBarChartArrecadacao = {
    chartData: {
        labels: [],
        datasets: [
            {
                label: ``,
                yAxisID: 'A',
                data: [],
                backgroundColor: [],
                maxBarThickness: 30,
            },
            {
                label: 'Pago Online',
                yAxisID: 'B',
                data: [],
                backgroundColor: 'transparent',
                borderColor: [],
                maxBarThickness: 30,
                type: 'line',
            },
            {
                label: 'Pago no Local',
                yAxisID: 'B',
                data: [],
                backgroundColor: 'transparent',
                borderColor: [],
                maxBarThickness: 30,
                type: 'line',
            }
        ]
    },
    extraOptions: {
        legend: {
            display: true,
            position: 'top'
        },
        animation: false,
        transitions: {
            ative: {
                animation: {
                    duration: 0,
                }
            }
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, yAxes) {
                    return ((tooltipItem.datasetIndex == 1 || tooltipItem.datasetIndex == 2)
                        ? "R$ " + Number(tooltipItem.value).toFixed(2).replace('.', ',')
                        : `${Number(tooltipItem.value)}`) + ' ' + yAxes.datasets[tooltipItem.datasetIndex]['label'];
                },
            },
            opacity: 0.1,
            yAlign: 'bottom',
            xAlign: 'center',
        },
        scales: {
            yAxes: [
            {
                id: 'A',
                type: 'linear',
                position: 'left',
                ticks: {
                    mirror: true,
                    autoSkip: true,
                    includeBounds: true,
                    display: true,
                    title: "Quantidade",
                },
            },
            {
                id: 'B',
                type: 'linear',
                position: 'right',
                ticks: {
                    callback: function (value, index, ticks) { return 'R$' + value; },
                    mirror: true,
                    autoSkip: true,
                    includeBounds: true,
                    display: true,
                    title: "Valor",
                }
            }],
        },
    }
}

const defaultBarChartProdutividade = {
    chartData: {
        labels: [],
        datasets: [{
            label: 'Operadores',
            data: [],
            barThickness: 8,
            maxBarThickness: 30,
        }],
    },
    extraOptions: {
        legend: { display: false },
        tooltips: {
            callbacks: {
                label: function (tooltipItem) { return Number(tooltipItem.value) + " check-ins"; }
            }
        },
    }
}

const defaultBarChartHorario = {

  "chartData":{
    "labels":["00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00","08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00"
    ],
    "datasets":[
        {
          "label":"Horário de reserva",
          "yAxisID":"A",
          "data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          "barThickness":8,
          "maxBarThickness":30,
          "borderColor":"#1D889C",
          "backgroundColor":"transparent",
          "type":"line"
        },
        {
          "label":"Horário de entrada (checkin)",
          "yAxisID":"A",
          "data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          "barThickness":8,
          "maxBarThickness":30,
          "borderColor":"#002C3B",
          "backgroundColor":"transparent",
          "type":"line"
        },
        {
          "label":"Horário Trafx",
          "yAxisID":"A",
          "data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          "barThickness":8,
          "maxBarThickness":30,
          "borderColor":"#AAF098",
          "backgroundColor":"transparent",
          "type":"line"
        }
    ]
  },
    extraOptions: {
        legend: {
            display: true,
            position: 'bottom'
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    if(tooltipItem.datasetIndex == 0){ return `${Number(tooltipItem.value)} reservaram` }
                    else if(tooltipItem.datasetIndex == 1){ return `${Number(tooltipItem.value)} fizeram check-in` }
                    else if(tooltipItem.datasetIndex == 2){ return `${Number(tooltipItem.value)} trafx contados` }
                }
            }
        },
        scales: {
            yAxes:[
                {
                    id: 'A',
                    type: 'linear',
                    position: 'left',
                }
            ],
        }
    }
}

const defaultBarChartVisitantes = {
    chartData: {
        labels: [],      //NOMES DOS LABELS DO PERIODO
        datasets: [
            {   label: `Qtd.`,
                yAxisID: 'A',
                data: [],               //VALOR DA QNTD DE VISITANTE POR PERIODO
                backgroundColor: [],
                maxBarThickness: 30,
            },
            {   label: 'Agendados',
                yAxisID: 'A',
                data: [],
                backgroundColor: 'transparent',
                borderColor: 'orange',
                type: 'line',
            },
            {   label: 'Trafx',
                yAxisID: 'A',
                data: [],
                backgroundColor: 'transparent',
                borderColor: 'green',
                type: 'line',
            },
        ],
    },
    extraOptions: {
        legend: { display: false, },
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    if(tooltipItem.datasetIndex == 0){ return `${Number(tooltipItem.value)} ${amountLabel}` }
                    else if(tooltipItem.datasetIndex == 1){ return `${Number(tooltipItem.value)} Vendas antecipadas` }
                    else if(tooltipItem.datasetIndex == 2){ return `${Number(tooltipItem.value)} Registros Trafx` }
                }
            }
        },
        scales: {
            yAxes: [
                {
                    id: 'A',
                    type: 'linear',
                    position: 'left',
                    title: 'Quantidade Visitantes',
                    barPercentage: 0.3,
                },
            ],
        },
    }
}

const defaultBarChartTamanho = {
    chartData: {
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [],
                groupCount: [],
                barThickness: [],
                maxBarThickness: [],
                yAxisID: 'A',
            },
            {
                data: [],
                backgroundColor: [],
                groupCount: [],
                barThickness: [],
                maxBarThickness: [],
                yAxisID: 'A',
            },
        ],
    },
    extraOptions: {
        legend: { display: false, },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    // BILLS PERSONs COUNT TOOLTIP
                    if(tooltipItem.datasetIndex == 0){
                        return tooltipItem.value + ' ' + _billName + ' - ' + (data.datasets[0]['groupCount'][tooltipItem.index]['count']);
                    }
                    // TRAFX TOOLTIP
                    if(tooltipItem.datasetIndex == 1){
                        const trafx_counts = (labels[tooltipItem.index].label * tooltipItem.value)
                        return `${Number(tooltipItem.value)} grupos Trafx - ` + trafx_counts + ` registros`
                    }
                }
            }
        },
        scales: {
            yAxes: [
                {
                    id: 'A',
                    type: 'linear',
                    position: 'left',
                    title: 'Qntd.',
                    barPercentage: 0.3,
                },
            ],
        },
    }
}

const defaultBarChartRankingVisitantes = {
    chartData: {
        labels: [],
        datasets: [{
            label: 'Qntd. no período',
            backgroundColor: [],
            data: [],
            barThickness: 8,
            maxBarThickness: 30,
        }],
    },
    extraOptions: {
        legend: {
            display: false
        },
    }
}

const defaultDoughnutChartVisitantes = {
  chartData: {
      labels: [],
      datasets: [{
          data: [],
          backgroundColor: [],
          barThickness: 8,
          maxBarThickness: 30,
      }],
  },
  extraOptions: {
      cutoutPercentage: 45,
      legend: {
          display: true,
          position: 'bottom',
      },
      tooltips: {
          mode: 'point',
          callbacks: {
              label: function (tooltipItem, data) {
                  return data.labels[tooltipItem.index] + ': ' + data.datasets[0]['data'][tooltipItem.index] + ' visitantes'
              }
          }
      },
  }
}


export default {
    defaultBarChartArrecadacao,
    defaultBarChartProdutividade,
    defaultBarChartRankingVisitantes,
    defaultBarChartHorario,
    defaultBarChartVisitantes,
    defaultBarChartTamanho,
    defaultDoughnutChartVisitantes
}
